import { Link } from "react-router-dom";

const testimonials = [
  { name: "追番小鹿", tag: "4年老用户", text: "在这里看番真的零门槛，点开就能追更，更新也很及时，体验比想象中顺畅太多了。" },
  { name: "阿哲不熬夜", tag: "下载党", text: "清晰度选择很全，1080P 直链复制就能下载，存番收藏特别方便，资源整理得井井有条。" },
  { name: "栗子同学", tag: "分类控", text: "分类很清晰，热血、悬疑、古风想找什么都有，高分榜单的质量也很稳，踩雷率超低。" },
];

export default function WordSection() {
  return (
    <section className="container-site py-10 md:py-14">
      <div className="grid gap-8 lg:grid-cols-3">
        {testimonials.map((t) => (
          <figure key={t.name} className="rounded-xl border border-background-800 bg-background-900 p-6">
            <div className="flex items-center gap-1 text-accent-400">
              {Array.from({ length: 5 }).map((_, i) => (
                <i key={i} className="ri-star-fill text-sm" />
              ))}
            </div>
            <blockquote className="mt-4 text-sm leading-relaxed text-foreground-300">“{t.text}”</blockquote>
            <figcaption className="mt-5 flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500/20 font-heading text-lg text-primary-400">
                {t.name.charAt(0)}
              </span>
              <div>
                <p className="text-sm font-bold text-foreground-100">{t.name}</p>
                <p className="text-xs text-foreground-500">{t.tag}</p>
              </div>
            </figcaption>
          </figure>
        ))}
      </div>

      <div className="relative mt-10 overflow-hidden rounded-2xl border border-primary-700/40 bg-gradient-to-r from-primary-950/60 to-accent-950/40 p-8 text-center md:p-12">
        <p className="font-heading text-2xl text-foreground-50 md:text-3xl">准备好了吗？点开即可开始追番</p>
        <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-300">
          上千部热门动画免费在线观看，全集收录与高清下载一应俱全，陪你度过每一个追番夜晚。
        </p>
        <div className="mt-6 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link to="/list" className="btn-primary">
            立即找番 <i className="ri-arrow-right-line ml-1" />
          </Link>
          <Link to="/about" className="btn-ghost">
            了解我们
          </Link>
        </div>
      </div>
    </section>
  );
}